<div id="container" (window:resize)="resize()">
  <div class="preview-msg" *ngIf="assetViewer === undefined || (assetViewer.resourceLoaded$ | async) === false"
       fxLayout="column"
       fxLayoutAlign="center center">
    Nothing to preview
  </div>
</div>
